module.exports = __webpack_public_path__ + "static/media/avatars_female_8.a33e0b32.png";